module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-up-gray-medium-34fa5ea529cf51969c304c85e985bcd8.png";